var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layer_section layer-area type-wide-a abo_promotion",
      attrs: { id: "aboPromotion" }
    },
    [
      _c("div", { staticClass: "layer_section-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "align-box size-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn-modal_close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("layer")
                }
              }
            },
            [_vm._v("확인")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer-content campaign-detail" }, [
      _c("h2", { staticClass: "campaign-detail__title" }, [
        _vm._v("\n              2023년 3월 신규 ABO 프로모션 "),
        _c("br", { staticClass: "mobile" }),
        _vm._v("후원 조건 안내\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "abo-guide" }, [
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v("1. 기간: 2023년 3월 2일(목)오전 9시~"),
            _c("br", { staticClass: "mobile" }),
            _vm._v("3월 31일(금) 오후 11시 50분")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      2. 대상자: 3월 1일 부 플래티늄 이상 ABO 리더님\n                  "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      3. 혜택: 국내 호텔/리조트 숙박권 바우처\n                  "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      4. 달성조건: 3월 1일 부 유자격 플래티늄 그룹 내 3월 신규 회원 프로모션 혜택을 받은 신규 회원을 30조 이상 후원 "
            ),
            _c("br"),
            _c("span", { staticClass: "color-gray" }, [
              _vm._v("(15만원 이상 구매한 신규 ABO를 30조 이상 후원)")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54513de4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54513de4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard2/component/layerAttainment.vue
// module id = null
// module chunks = 